export const AgentsMandataires: string[] = [
	"Agent indépendant",
	"1894 - L'immobilier",
	"3%.COM",
	"3G IMMO",
	"À la bonne porte",
	"A la lucarne de l'immobilier",
	"A&M Immobilier",
	"Abessan immobilier",
	"Abriculteur",
	"Acquer'immo",
	"ADELIMO Immobilier",
	"ADRIA Immobilier",
	"ADVICIM",
	"Agence à taux réduits",
	"Agent Immobilier Privé",
	"AgentMandataire.fr",
	"AKOMI",
	"ALCBIMMO",
	"AMKER",
	"Anov'Immo",
	"Ashler & Manson",
	"AV Transaction",
	"AXESSION FRANCE",
	"AXO - L'immobilier Actif",
	"Bien avec vous",
	"Biensavendre.com",
	"BL Agents immobiliers",
	"Bonne Étoile",
	"Bring’s",
	"BSK Immobilier",
	"BUYHOM",
	"C2i Groupe",
	"Capifrance",
	"Casarèse",
	"Chasseur2Renta",
	"CityGest",
	"Coeur Immobilier",
	"Comptoir Immobilier de France",
	"Conseillers.immo",
	"Côté France Immobilier",
	"Côté immobilier",
	"CPH Immobilier",
	"DE LA COUR AU JARDIN",
	"Domini",
	"Domium Groupe Immobilier",
	"Dr House Immo",
	"Driver immobilier",
	"Dupont Expertise Immobilier",
	"E-mobilier.fr",
	"Effectimmo",
	"Efficity",
	"ELEVEN immobilier",
	"Elyse Avenue",
	"ENDIE FRANCE",
	"Excellia Immobilier",
	"eXp France",
	"Expertimo",
	"FamiCity Immobilier",
	"Fides Hermes",
	"FIJ Immobilier",
	"FRANCE PROPRIO",
	"Gabriel",
	"Gateway Immobilier",
	"Global Immobilier",
	"Groupement Immobilier",
	"GUSAN",
	"HA.IMMO",
	"HARMONY IMMO",
	"Hermitage Immobilier",
	"hiin immobilier",
	"Hubert IMMO",
	"iad FRANCE",
	"ICOCC",
	"iDAL FRANCE",
	"Idimmo",
	"IDLR",
	"Ikami",
	"Immeuble-locatif.com",
	"IMMO CONSEIL FINANCE",
	"Immo reseau",
	"Immo-Diffusion",
	"Immobilier et Patrimoine",
	"ImmoForfait",
	"Immojoy",
	"Immoliaison",
	"IMMÖÖ",
	"Immosurmesure",
	"IMOCONSEIL France",
	"IMOGROUP",
	"Imonet",
	"INNOVE IMMO",
	"INSTANTiMMO",
	"ISADEC",
	"ISP GROUP",
	"Jovimmo",
	"Ketzinger Real Estate",
	"Keymex",
	"Klicc Immobilier",
	"L'ACCENT RÉSEAU IMMOBILIER",
	"L'affiche immobilière",
	"L'agence exclusive",
	"La fédération de l’immobilier",
	"La Rose des Ventes",
	"LCD NORD IMMO",
	"Le Bon Agent",
	"Le Club 90",
	"Le Club immobilier Français",
	"Ledil Immobilier",
	"Les porteclés",
	"Les Professionnels Immo",
	"LEXAA immobilier",
	"LF immo",
	"Liberkeys",
	"Lifehome",
	"LMD Immobilier",
	"Logimm",
	"LOTIER IMMOBILIER",
	"LYSI Immobilier",
	"Ma Pépite Immo",
	"Ma Petite Agence",
	"Maclès immobilier",
	"Man Immo Pro",
	"Marketplace Immobilier",
	"Masteos",
	"Maxihome",
	"MAXimmo",
	"megAgence",
	"Meilleur Conseil Immo",
	"MeilleursBiens",
	"Mon Chasseur Immo",
	"Mon-habitat.com",
	"Monreseau-immo.com",
	"My Family Immo",
	"My French Agent",
	"My Home Store",
	"Mychezmoi",
	"NAD IMMO",
	"NAOS immobilier",
	"NEOM",
	"Neos Immo",
	"Net Immo 31",
	"New Deal Immobilier",
	"Nidéal",
	"Noovimo",
	"oovéa & Co",
	"Open Immobilier",
	"Optimhome",
	"OTAREE",
	"Ozéo Immo",
	"PlugIMMO",
	"Pour vous loger",
	"Power Immo",
	"Prince Patrimoine",
	"PROJETLOCATIF",
	"PROJETS IMMOBILIERS",
	"Prompt Immo",
	"Property-Partners",
	"Proprietes-privees.com",
	"REGM",
	"Réseau BROKERS",
	"Réseau EV Immobilier",
	"RESEAU FRANCE IMMOBILIER",
	"RESEAU HB",
	"Réseau Immo Direct",
	"Réseau M6C",
	"Réseau Stormer",
	"RéseauVendéen.immo",
	"Rochella",
	"SAFTI",
	"Sextant France & International",
	"Solution.immo",
	"Sourcing Invest",
	"STARTGO IMMO",
	"Sweven Immobilier",
	"Syndeo",
	"Tacit'immo",
	"TeamFi TEAM FRANCE IMMOBILIER",
	"TEATIME IMMO",
	"The Door Man",
	"Tom Immobilier",
	"Tower Immobilier",
	"Twitim Immobilier",
	"Univers City Immo",
	"Valeur immobilière",
	"VENDMY",
	"Vente Urgente",
	"Vente-de-Neuf.com",
	"WALTER & DE MAISON",
	"We Invest",
	"Weelodge",
	"WelcomeHome Immobilier",
	"Weloge",
	"Win Win Immobilier",
	"Winkey",
	"Xlm",
	"Win Win Immobilier",
	"Winkey",
	"Xlm"
]
